<template>
  <Menu v-slot="{ open }">
    <!-- Dummy node to notify this component when the Popover opens or closes -->
    <template v-if="isOpen(open)"> </template>
    <Float
      portal
      :placement="props.placement"
      :offset="8"
      :shift="8"
      :z-index="30"
      flip
      enter="transition ease-out duration-100"
      enter-from="transform opacity-0 scale-95"
      enter-to="transform opacity-100 scale-100"
      leave="transition ease-in duration-75"
      leave-from="transform opacity-100 scale-100"
      leave-to="transform opacity-0 scale-95"
      tailwindcss-origin-class
    >
      <slot name="trigger" />

      <MenuItems
        :class="[widthClass]"
        class="max-w-[calc(100vw-32px)] divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none dark:divide-gray-500 dark:bg-gray-700"
      >
        <slot />
      </MenuItems>
    </Float>
  </Menu>
</template>

<script setup>
import { Float } from '@headlessui-float/vue'
import { Menu, MenuItems } from '@headlessui/vue'
import { computed, ref } from 'vue'

const props = defineProps({
  placement: {
    type: String,
    default: 'bottom-start',
  },
  width: {
    type: String,
    default: 'md',
  },
})

const widthClass = computed(() => {
  return {
    sm: 'w-48',
    md: 'w-56',
    max: 'min-w-max',
    auto: null,
  }[props.width]
})

// Open and close events
const emit = defineEmits(['open', 'close'])

const localOpen = ref(false)

function isOpen(open) {
  if (localOpen.value === true && open === false) emit('close')
  else if (localOpen.value === false && open === true) emit('open')

  localOpen.value = open
}
</script>
